import { openBlock, createElementBlock, createStaticVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-veranda-icon"
};
const _hoisted_1 = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "currentColor",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<path d="M11.6072 16.5H17.6072V10.75H11.6072V16.5ZM13.0088 13.788L14.6452 12.1517C14.7625 12.0347 14.9522 12.0347 15.0695 12.1517L15.7058 12.788C15.8232 12.9053 15.8232 13.095 15.7058 13.2123L14.0695 14.8487C13.9522 14.966 13.7625 14.966 13.6452 14.8487L13.0088 14.2123C12.8915 14.095 12.8915 13.905 13.0088 13.788Z" fill="#DDD4FB"></path><path d="M17.6072 9.25H11.6072V3.25H11.8572C15.0282 3.25 17.6072 5.829 17.6072 9V9.25Z" fill="#DDD4FB"></path><path d="M10.1072 3.25H9.85718C6.68618 3.25 4.10718 5.829 4.10718 9V9.25H10.1072V3.25ZM8.70551 6.212L7.06918 7.84833C6.95185 7.96567 6.76218 7.96567 6.64484 7.84833L6.00851 7.212C5.89118 7.095 5.89118 6.905 6.00851 6.78767L7.64484 5.15133C7.76218 5.03433 7.95185 5.03433 8.06918 5.15133L8.70551 5.78767C8.82284 5.905 8.82284 6.095 8.70551 6.212Z" fill="#DDD4FB"></path><path d="M4.10718 10.75H10.1072V16.5H4.10718V10.75Z" fill="#DDD4FB"></path><path d="M2.60718 16.5H0.857178V9C0.857178 4.02933 4.88651 0 9.85718 0H11.8572C16.8278 0 20.8572 4.02933 20.8572 9V16.5H19.1072V9C19.1072 5.002 15.8552 1.75 11.8572 1.75H9.85718C5.85918 1.75 2.60718 5.002 2.60718 9V16.5Z" fill="#7442EC"></path><path d="M0.875122 17.36H20.8494V19.18H0.875122V17.36Z" fill="#7442EC"></path>', 6);
const _hoisted_8 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_8);
}
const uikitVerandaIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  uikitVerandaIcon as default
};
//# sourceMappingURL=uikit-veranda-icon.vue.es.js.map
